import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { CoreModule } from './restaurent-management/core/core.module';
import { SharedModule } from './restaurent-management/shared/shared.module';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './restaurent-management/layout/header/header.component';
import { PageLoaderComponent } from './restaurent-management/layout/page-loader/page-loader.component';
import { SidebarComponent } from './restaurent-management/layout/sidebar/sidebar.component';
import { RightSidebarComponent } from './restaurent-management/layout/right-sidebar/right-sidebar.component';
import { AuthLayoutComponent } from './restaurent-management/layout/app-layout/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './restaurent-management/layout/app-layout/main-layout/main-layout.component';
import { LocationStrategy, HashLocationStrategy, DatePipe } from '@angular/common';
import  {WincentInterceptor} from './restaurent-management/interceptor/winent-interceptor';
import { AppService } from './app.service';
import { ExcelService } from './exportexcel.service';
import { AmazingTimePickerModule } from 'amazing-time-picker'; 
import {
  PerfectScrollbarModule,
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface,
} from 'ngx-perfect-scrollbar';  

import { ClickOutsideModule } from 'ng-click-outside';
import { HttpClientModule,HTTP_INTERCEPTORS } from '@angular/common/http';
import { BnNgIdleService } from 'bn-ng-idle';
import { MAT_DATE_LOCALE } from '@angular/material/core';
// import { NumbersOnlyDirective } from './numbers-only.directive';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelPropagation: false,
};

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    PageLoaderComponent,
    SidebarComponent,
    RightSidebarComponent,
    AuthLayoutComponent,
    MainLayoutComponent,
    // NumbersOnlyDirective,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    PerfectScrollbarModule,
    ClickOutsideModule,
    // core & shared
    CoreModule,
    SharedModule,
    AmazingTimePickerModule,
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },BnNgIdleService,AppService,ExcelService,
    { provide: HTTP_INTERCEPTORS, useClass: WincentInterceptor, multi: true },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    DatePipe,
  ],
  entryComponents: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
